<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import BirimSecimi from "../FormComponet/BirimSecimiAnaBirim.vue";
import riskeylemonaydurum from "../StrRaporlar/RiskRaporlari/riskeylemonaydurum.vue";
import riskkarsilastirmaraporu from "../StrRaporlar/RiskRaporlari/riskkarsilastirmaraporu.vue";
import Konsolideraporu from '../StrRaporlar/RiskRaporlari/konsolideraporu.vue';
import riskoylamaraporu from '../StrRaporlar/RiskRaporlari/riskoylamaraporu.vue';
import riskkayitformu from '../StrRaporlar/RiskRaporlari/riskkayitformu.vue';
import verigirisraporu from '../StrRaporlar/RiskRaporlari/verigirisraporu.vue';
import kurumsalriskraporu from '../StrRaporlar/RiskRaporlari/kurumsalriskraporu.vue';
import riskonemraporu from '../StrRaporlar/RiskRaporlari/riskonemraporu.vue';
import riskeylemplani from '../StrRaporlar/RiskRaporlari/riskeylemplani.vue';
import riskkayitformurize from '../StrRaporlar/RiskRaporlari/riskkayitformurize.vue';

import riskdegerlendirmeverigirisdurum from '../StrRaporlar/RiskRaporlari/riskdegerlendirmeverigirisdurum.vue';

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Risk Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    BirimSecimi,
    riskkarsilastirmaraporu,
    Konsolideraporu,
    riskoylamaraporu,
    riskkayitformu,
    verigirisraporu,
    kurumsalriskraporu,
    riskonemraporu,
    riskeylemplani,
    riskkayitformurize,
    riskeylemonaydurum,
    riskdegerlendirmeverigirisdurum

  },
  data() {
    return {
      title: "Risk raporları",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurumsal Performans",
          active: true,
        },
        {
          text: "Risk Raporları",
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },
      counter: 0,
      UstDonemId: null,
      secilen_birim: "",
      secilen_donem: "",
      secilen_alt_donem:"",
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxGDonemler: [],
      ComboboxBirimler: [],
      YuklenenTablolar: [],
      TabloDetaylar: [],
      Isbirlikciler: [],
      TabloDetay:{},
      Secilen: null,
      sorgula:0,
      Raporgirisid: "",
      DetayId:"",
      TabloDetayAciklama:"",
      DonemId:"",
      Hesaplanmasin:"",
      AltDonemlerDetay:[],
      BirimId:"",
      Tablo:0,
      Filter: {
        DonemId: "",
        GdonemId: "",
        KdonemId:"",
        BirimId: null,
      },
    };
  },

  methods: {
    /* ANCHOR Combobox yükleme metodları */
    gdonem_combo_yukle(ust_id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.Filter.GdonemId="";
      this.Filter.TabloId="";
      this.UstDonemId = ust_id;

      this.ComboboxGDonemler = [];


      let Filter = "&UstId=" + ust_id;
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page, Filter:Filter}).then((res) => {
        this.ComboboxGDonemler = res.Data;

      });

      
    },

    Secilmis_Idler(secilmis) {
      this.Filter.BirimId=secilmis;    
    },

    tablo_combo_yukle(birim_id) {
        if (this.Filter.DonemId != null && this.Filter.DonemId != "") {
            this.secilen_birim = birim_id;
            this.secilen_donem = this.UstDonemId;

            //this.gdonem_combo_yukle(this.UstDonemId);
        } else {
            this.makeToast();
        }
    },

    /* ANCHOR yükleme butonu kodu */
    kurumsalveoperasyonel_yukle() { //Kurumsal / Operasyonel Risk Raporu
      
       if (this.Filter.GdonemId!="" && this.Filter.GdonemId!=null
       && this.Filter.KdonemId!="" && this.Filter.KdonemId!=null) {
     
        this.Tablo=1;
        this.sorgula=this.sorgula+1;

      } else {
            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo1Mesaj');
            this.Message.showConfirmButton = false;
            this.Message.timer = 1000;

            Vue.swal(this.Message);
      }
    },

    konsolide_yukle() { //Konsolide raporu
      
        if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
        this.Filter.GdonemId!="" && this.Filter.GdonemId!=null ) {
     
        this.Tablo=2;
        this.sorgula=this.sorgula+1;

      } else {
            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo2Mesaj');
            this.Message.showConfirmButton = false;
            this.Message.timer = 2000;

            Vue.swal(this.Message);
      }
    },

    riskoylama_yukle() { //risk oylama
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null 
       ) {
   
      this.Tablo=3;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo3Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },

  riskkayitformu_yukle() { //Risk Kayıt Formu
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null ) {
   
      this.Tablo=4;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo4Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },

  riskkayitformurize_yukle() { //Risk Kayıt Formu
      
    if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null  ) {
   
      this.Tablo=9;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo6Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },

  verigirisdurum_yukle() { //veri giriş durumları
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null
        ) {
   
      this.Tablo=5;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo5Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },
  kurumsalrisk_yukle() { //Kurumsal Risk Raporu
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null  ) {
   
      this.Tablo=6;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo6Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },

  riskonem_yukle() {
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null 
        ) {
   
      this.Tablo=7;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo7Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },

  riskeylem_yukle() { //Risk Eylem PLanı
      
      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null  ) {
   
      this.Tablo=8;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo8Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },
  riskeylemonaydurum_yukle(){
    if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null  ) {
   
      this.Tablo=10;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo10Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },
riskdegerlendirmeonaydurum_yukle(){
    if (this.Filter.DonemId!="" && this.Filter.DonemId!=null && 
      this.Filter.GdonemId!="" && this.Filter.GdonemId!=null  ) {
   
      this.Tablo=11;
      this.sorgula=this.sorgula+1;

    } else {
          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = this.$t('RiskRaporlari.Mesajlar.Tablo10Mesaj');
          this.Message.showConfirmButton = false;
          this.Message.timer = 2000;

          Vue.swal(this.Message);
    }
  },


    Get() {
  
    },

    ChangePage(DefaultPage) {
      if (DefaultPage) {
        this.Page.PageNumber = DefaultPage;
        this.Get();
      }
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },

  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==5 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });



    this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {
      this.ComboboxBirimler = res.Data;
    });
  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <!-- ANCHOR Filtreleme form alanı -->
  

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-5">

                  <b-form-group
                    class="mb-3"
                    id="donemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.DonemId"
                      @change="gdonem_combo_yukle(Filter.DonemId)"
                      class="form-select"
                      type="text"
                    >
                      <option value=""
                        >{{$t('RiskRaporlari.Filtreleme.UstId')}}</option
                      >
                      <option
                        v-for="DonemVerileri in ComboboxDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                       {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                     <!--{{Filter.DonemId}}--> 


                  <b-form-group
                    class="mb-3"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.GdonemId"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('RiskRaporlari.Filtreleme.DonemId')}}</option>
                      <option
                        v-for="DonemVerileri in ComboboxGDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                        {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>
                <!-- {{Filter.GdonemId}} -->

                <b-form-group
                    class="mb-3"
                    id="gdonemler"
                    label=""
                    label-for="text"
                  >
                    <select
                      v-model="Filter.KdonemId"
                      class="form-select"
                      type="text"
                    >
                      <option value="">{{this.$t('RiskRaporlari.Filtreleme.DonemId2')}}</option>
                      <option
                        v-for="DonemVerileri in ComboboxGDonemler"
                        :key="DonemVerileri.Id"
                        :value="DonemVerileri.Id"
                      >
                        {{ DonemVerileri.Aciklama }}
                      </option></select
                    >
                  </b-form-group>



                  <BirimSecimi
                    :title="''"
                    :title_class="'mb-3'"
                    :closeOnSelect="true"
                    :sutun="'0'"
                    :multiple="false"
                    :YetkiKontrol="1"
                    :personel_id="null"
                    :BirimTipId="null"
                    @Secilmis_Idler="Secilmis_Idler($event)"
                  />
                  <!--   {{secilen_birim}}  -->

    
        
                </div>
   
                <!-- ANCHOR Rapor Çıktıları alanı -->
                <div class="col-md-7">
               
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap table-centered table-hover mb-0 align-middle"
                        >
                          <tbody>
                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                 
                                  <a href="javascript: void(0);"
                                    @click="kurumsalveoperasyonel_yukle()"
                                    class="text-dark">
                                    <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.karsilastirma')}}</span>
                                    </a>
                                </h5>
                              </td>
                               <td>
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="konsolide_yukle()"
                            
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.konsolide')}}</span></a
                                  >
                                </h5>
                              </td>
                            </tr>
                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                 
                                  <a href="javascript: void(0);"
                                    @click="riskoylama_yukle()"
                                    class="text-dark">
                                    <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.riskoylama')}}</span>
                                    </a>
                                </h5>
                              </td>
                               <td>
                                
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="riskkayitformu_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.riskkayit')}}</span></a
                                  >
                                </h5>
                             
                              </td>
                            </tr>

                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                 
                                  <a href="javascript: void(0);"
                                    @click="verigirisdurum_yukle()"
                                    class="text-dark">
                                    <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.verigiris')}}</span>
                                    </a>
                                </h5>
                              </td>
                               <td>

                                <h5 class="font-size-14 mb-0">
                                 
                                 <a href="javascript: void(0);"
                                   @click="kurumsalrisk_yukle()"
                                   class="text-dark">
                                   <i class="fas fa-print"></i>
                                   <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.kurumsalrisk')}}</span>
                                   </a>
                               </h5>
                             
                              </td>
                            </tr>
                            <tr>
                             
                               <td>
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="riskonem_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.onemderecesi')}}</span></a
                                  >
                                </h5>
                              </td>
                              <td width="500">

                                <h5 class="font-size-14 mb-0">
                                 
                                 <a href="javascript: void(0);"
                                   @click="riskeylem_yukle()"
                                   class="text-dark">
                                   <i class="fas fa-print"></i>
                                   <span style="margin-left: 10px;">{{this.$t('RiskRaporlari.Raporlar.riskeylemplani')}}</span>
                                   </a>
                               </h5>
                                
                              </td>
                            </tr>

                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="riskkayitformurize_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">Risk Kayıt Formu (Rize)</span></a
                                  >
                                </h5>
                              
                              </td>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="riskeylemonaydurum_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">Risk Eylem Planı Onay Durumları (Birim Bazlı)</span></a
                                  >
                                </h5>
                              
                              </td>
                            </tr>

                            <tr>
                              <td width="500">
                                <h5 class="font-size-14 mb-0">
                                  <a
                                    href="javascript: void(0);"
                                    @click="riskdegerlendirmeonaydurum_yukle()"
                                    class="text-dark"
                                    > <i class="fas fa-print"></i>
                                    <span style="margin-left: 10px;">Risk Değerlendirme Onay Durumları (Birim Bazlı)</span></a
                                  >
                                </h5>
                              
                              </td>
                            </tr>
                            
                            
                            
                         
                          </tbody>
                        </table>
                      </div>
                    
                  <br>
                  <br>
                </div>

              </div>
            </div>
          </div>
        </div>



      </div>

      
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">

                <riskkarsilastirmaraporu v-if="Tablo==1"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :KAltDonemId="Filter.KdonemId"
                  :Sorgulama="sorgula"
                />


                <konsolideraporu v-if="Tablo==2"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :KAltDonemId="Filter.KdonemId"
                  :Sorgulama="sorgula"
                />

                <riskoylamaraporu v-if="Tablo==3"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskkayitformu v-if="Tablo==4"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <verigirisraporu v-if="Tablo==5"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <kurumsalriskraporu v-if="Tablo==6"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskonemraporu v-if="Tablo==7"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskeylemplani v-if="(Tablo==8)"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskkayitformurize v-if="Tablo==9"
                  :BirimId="Filter.BirimId"
                  :DonemId="Filter.DonemId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskeylemonaydurum v-if="Tablo==10"
                  :BirimId="Filter.BirimId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

                <riskdegerlendirmeverigirisdurum v-if="Tablo==11"
                  :BirimId="Filter.BirimId"
                  :AltDonemId="Filter.GdonemId"
                  :Sorgulama="sorgula"
                />

    

            </div>
          </div>
        </div>
      </div>

    



    </Layout>
  </Loader>
</template>

